const name = 'chatExample'
export default name
